var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.373,
    height: 16.124,
    viewBox: "0 0 19.373 16.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-users",
    "data-name": "Icon feather-users",
    transform: "translate(-0.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9326",
    "data-name": "Path 9326",
    d: "M14.5,28.125a.75.75,0,0,1-.75-.75V25.75a2.5,2.5,0,0,0-2.5-2.5H4.75a2.5,2.5,0,0,0-2.5,2.5v1.625a.75.75,0,0,1-1.5,0V25.75a4,4,0,0,1,4-4h6.5a4,4,0,0,1,4,4v1.625A.75.75,0,0,1,14.5,28.125Z",
    transform: "translate(0 -8.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9327",
    "data-name": "Path 9327",
    d: "M10.75,11.749a4,4,0,1,1,4-4A4,4,0,0,1,10.75,11.749Zm0-6.5a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,10.75,5.25Z",
    transform: "translate(-2.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9328",
    "data-name": "Path 9328",
    d: "M32.437,28.214a.75.75,0,0,1-.75-.75V25.839a2.5,2.5,0,0,0-1.875-2.418.75.75,0,1,1,.375-1.452,4,4,0,0,1,3,3.87v1.625A.75.75,0,0,1,32.437,28.214Z",
    transform: "translate(-13.064 -8.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9329",
    "data-name": "Path 9329",
    d: "M24,11.741a.75.75,0,0,1-.185-1.477,2.5,2.5,0,0,0,0-4.843.75.75,0,0,1,.372-1.453,4,4,0,0,1,0,7.749A.752.752,0,0,1,24,11.741Z",
    transform: "translate(-10.314 -0.089)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorManagementIcon);
export default __webpack_public_path__ + "static/media/vendor-management-icon.9ba9539c4608b082551c66c3716e9d2e.svg";
export { ForwardRef as ReactComponent };